import { sendText } from "../hooks/useConversation.js";

// Botones del pipeline ({id,title}) renderizados como chips tocables bajo el
// último mensaje del bot — semántica idéntica a los botones de WhatsApp:
// tocar el chip envía su título como texto.
export function QuickReplyChips({ message }) {
  const buttons = message?.buttons;
  if (!Array.isArray(buttons) || buttons.length === 0) return null;

  return (
    <div class="mt-2 flex flex-wrap gap-2 pl-1">
      {buttons.map((b) => (
        <button
          key={b.id || b.title}
          type="button"
          class="rounded-full border border-flux-primary/40 bg-white px-3.5 py-1.5 text-sm text-flux-primary shadow-sm active:bg-flux-primary/10 dark:border-flux-cyan/40 dark:bg-slate-800 dark:text-flux-cyan"
          onClick={() => sendText(b.title)}
        >
          {b.title}
        </button>
      ))}
    </div>
  );
}
